import React, { useEffect } from 'react';
import {
  QlfConfirmationDialog,
  useConfirmationDialog,
  useQlfTranslation,
} from '@qualifio/ui-commons';
import { RuleLastModificationInfo, RuleType } from '@loyalty/shared-common/rule-api-client';
import { useRules } from '../RulesContext';

export interface RuleConflictModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  ruleType: RuleType;
  lastModification?: RuleLastModificationInfo;
}

export function RuleConflictModal(props: RuleConflictModalProps) {
  const { t } = useQlfTranslation('translation');
  const { fetchRules } = useRules();
  const { confirmationDialogState, setConfirmationDialogState } = useConfirmationDialog();
  const username =
    props.lastModification?.userName ?? t('rules.conflict.modal.username.placeholder');
  useEffect(() => {
    if (props.isOpen) {
      setConfirmationDialogState(prev => ({
        ...prev,
        open: true,
        color: 'error',
        title: t('rules.conflict.modal.title'),
        content: t('rules.conflict.modal.description', { username }),
        confirmButtonColor: 'secondary',
        confirmButtonText: t('rules.conflict.modal.confirm'),
        onConfirm: () => {
          fetchRules(props.ruleType);
          props.setIsOpen(false);
        },
        onClose: () => {
          props.setIsOpen(false);
        },
      }));
    } else {
      setConfirmationDialogState(prev => ({ ...prev, open: false }));
    }
  }, [props.isOpen]);

  return <QlfConfirmationDialog {...confirmationDialogState} />;
}
